import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "input_container" }
const _hoisted_5 = { class: "input_container" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import SimpleLayout from '@/layouts/simple/SimpleLayout.vue';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import logoImage from '@/assets/images/BeePallet_Logo_Black.png';
import {showErrorAlert, showExceptionAlert} from "@/helpers/SweetAlertHelper";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import * as Session from "supertokens-web-js/recipe/session";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import LoadingComponent from '@/components/common/LoadingComponent/LoadingComponent.vue';
import {initAppStore} from "@/store/init";
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogInPage',
  setup(__props) {

const store = useStore();
const email = ref('');
const password = ref('');
const router = useRouter();
const isLoading = ref<boolean>(false);
// const logoImageRef = logoImage;

const handleSubmit = async () => {
  try {
    isLoading.value = true;
    const response = await EmailPassword.signIn({
      formFields: [
        { id: "email", value: email.value },
        { id: "password", value: password.value },
      ],

    });

    if (response.status === "OK") {
      var isEmailVerified = await EmailVerification.isEmailVerified();

      if(!isEmailVerified.isVerified) {
        await EmailVerification.sendVerificationEmail();
        showErrorAlert("Por favor, verifica tu correo electrónico para continuar.");
        await Session.signOut();
        LocalStorageService.clearAll();
        return;
      }

      await initAppStore();

      const customerProfile = store.state.profile;

      (customerProfile?.name)?router.push({ name: "home" }):router.push({  name: "customer_profile" });

    } else {
      showErrorAlert("Email o contraseña invalidos");

    }
  } catch (error) {
    showExceptionAlert(error);
  }
  finally{
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(SimpleLayout, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "home" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(logoImage),
                class: "beepallet-logo",
                alt: "Logo de BeePallet"
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createElementVNode("form", {
            class: "login-form",
            onSubmit: _withModifiers(handleSubmit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("label", {
                class: "input_label",
                for: "username"
              }, "E-mail", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input-field is-placeholder",
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, email.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("label", {
                class: "input_label",
                for: "password"
              }, "Contraseña", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "password",
                class: "input-field is-placeholder",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, password.value]
              ])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("button", {
              type: "submit",
              class: "btn-primary-m btn-primary-green"
            }, "Conectarse", -1)),
            _createVNode(_component_router_link, {
              to: "/auth/register",
              class: "btn-secondary-black"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" ¿No tienes una cuenta? "),
                _createElementVNode("span", { class: "highlight" }, "Regístrate", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name: 'forgot_password'},
              class: "btn-secondary-s btn-underline-black"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("He olvidado la contraseña")
              ])),
              _: 1
            })
          ], 32)
        ]),
        _createVNode(LoadingComponent, {
          overlay: true,
          "is-loading": isLoading.value
        }, null, 8, ["is-loading"])
      ])
    ]),
    _: 1
  }))
}
}

})